import { getBennieSessionConfigOrNull } from './config';
import { exchangeBennieSession } from './exchange';
import { getOktaAccessToken } from './oktaToken';
import { needsSessionRefresh } from './signal';

/**
 * Ensures a valid Bennie session exists by checking the signal cookie
 * and triggering a JWT exchange if the session is stale or absent.
 *
 * No-ops silently if `initBennieSessionConfig` was never called (e.g. when
 * the runtime environment could not be resolved at startup).
 */
export async function ensureBennieSession(oktaAuth) {
  const config = getBennieSessionConfigOrNull();

  if (!config) {
    return;
  }

  if (!needsSessionRefresh(config.signalCookieName)) {
    return;
  }

  await exchangeBennieSession(() => getOktaAccessToken(oktaAuth));
}
